import { useEffect, useRef, useState } from 'react';

interface ImageCalculatedHeightProps {
  defaultHeight: number;
}

export const useImageCalculatedHeight = ({
  defaultHeight,
}: ImageCalculatedHeightProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [calculatedHeight, setCalculatedHeight] = useState(defaultHeight);

  useEffect(() => {
    const imgRefCurrent = imgRef.current;

    const updateHeight = () => {
      setCalculatedHeight(imgRefCurrent?.height ?? defaultHeight);
    };

    const resizeObserver = new ResizeObserver(() => updateHeight());
    if (imgRefCurrent) {
      resizeObserver.observe(imgRefCurrent);
    }

    window.addEventListener('resize', updateHeight);

    updateHeight();

    return () => {
      window.removeEventListener('resize', updateHeight);
      if (imgRefCurrent) {
        resizeObserver.unobserve(imgRefCurrent);
      }
    };
  }, [defaultHeight]);

  return { imgRef, calculatedHeight };
};
